import script from "./HeartBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./HeartBtn.vue?vue&type=script&setup=true&lang=js"

import "./HeartBtn.vue?vue&type=style&index=0&id=c7e54452&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7e54452"]])

export default __exports__